import { Component, OnInit, HostListener, ViewChild } from "@angular/core";
import { ChartStateComponent } from "../layout/chart-state/chart-state.component";
import { ReintegrosService } from "src/app/services/reintegros.service";
import Swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { ReportesService } from "src/app/services/reportes.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "src/app/services/helper.service";
import { SelectsService } from "src/app/services/selects.service";
import * as _moment from "moment";
import { ChartDataSets, ChartOptions, ChartType } from "chart.js";
import { MultiDataSet, Label, Color, Colors } from "ng2-charts";
import { OrdenModel } from "src/app/models/orden.model";
import { BackEndService } from "src/app/services/back-end.service";
const moment = (_moment as any).default ? (_moment as any).default : _moment;
declare let $: any;

@Component({
  selector: "app-reportes",
  templateUrl: "./reportes.component.html",
  styleUrls: ["./reportes.component.scss"]
})
export class ReportesComponent implements OnInit {
  public identity: any;
  public totalGeneralReport: number;
  public data: any = {};
  public title = "CoviRecupera";
  public blankState = true;
  public onCharge = true;
  public actives: any = 0;
  public recovered: any = 0;
  public retired: any = 0;
  public dataObj = {};
  public contract: string;

  // Progress bar
  public onManagementBar: number;
  public recoveredBar: number;
  public rectiredBar: number;
  public obligations: number;
  public percentManagement: any;

  // Dates
  public initDate: any;
  public endDate: any;
  public dateNow: Date = new Date();
  public dateHasChanged = false;

  // Angular
  @ViewChild("GraficaEstadoGestiones")
  GraficaEstadoGestiones: ChartStateComponent;

  // Totales
  public totalObligations = 0;
  public cantObligations = 0;
  public dataAverage = [];

  // fechas
  public date1: any;
  public date2: any;
  public min = new Date("2016-01-02");
  public max = new Date();
  public selectedMoments = [];

  // Ajax
  public dataWebContracts: any;
  public dataIndividual: any;
  public existsDataIndividual: boolean = true;
  public dataConsolidate: any;
  // Ajax management
  public dataCalls: any;
  public dataChatCenter: any;
  public dataMoreManagements: any;
  public dataMiCovinoc: any;
  public dataTotalManagements: any;
  // Ajax reports
  public dataDeptorReport: any;
  public dataReport: any;
  public dataTotalValues: any;

  public analytics: any;

  

  public dataAffiliate = {
    contrato: "",
    fecha_inicial: "",
    fecha_final: ""
  };

  // Declare height and width variables
  public innerWidth: any;
  public screenHeight: any;
  public isShowWidth: boolean;
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.screenHeight = window.innerHeight;
    this.innerWidth = window.innerWidth;

    if (this.innerWidth >= 900) {
      this.isShowWidth = true;
    } else {
      this.isShowWidth = false;
    }
  }
  public datas: any = [];



  constructor(
    private refundsService: ReintegrosService,
    private reportsService: ReportesService,
    private spinner: NgxSpinnerService,
    public helper: HelperService,
    private toastr: ToastrService,
    private selects: SelectsService
  ) { }

  ngOnInit() {
    this.analytics = JSON.parse(localStorage.getItem("identityCVE"));
    this.innerWidth = window.innerWidth;
    this.isShowWidth = this.innerWidth >= 900 ? true : false;

  }

  search({ initDate, endDate, contract, dateHasChanged }) {
    this.contract = contract;
    this.getReport(contract);
    this.getReportCharts(contract);
    this.getReportDebtors(contract);
    this.dateHasChanged = dateHasChanged;
    this.initDate = initDate;
    this.endDate = endDate;

    (window as any).gtag("event", "buscar_reportes", {
      event_category: `${this.analytics.v_tipo_documento} ${this.analytics.v_documento}`,
      event_label: ""
    });

    this.date1 = moment(initDate, "DD/MM/YYYY").format("DD/MM/YYYY");
    this.date2 = moment(endDate, "DD/MM/YYYY").format("DD/MM/YYYY");
    this.dataAffiliate.contrato = contract;
    this.dataAffiliate.fecha_inicial = this.date1;
    this.dataAffiliate.fecha_final = this.date2;
    setTimeout(() => {
      this.onCharge = false;
    }, 1500);

    this.getManagement(this.dataAffiliate);
    //this.management("EN GESTION");
  }

  

  getReport(contrato: string) {
    this.reportsService.getDebtReport({ contrato }).subscribe(
      (resp: any) => {
        if (resp.PORCENTAJES) {
          const {
            EN_GESTION,
            RECUPERADOS,
            RETIRADOS
          } = resp.PORCENTAJES;
          const { TOTALES } = resp;
          const { TOTAL_OBLIGACIONES } = resp.OBLIGACIONES;
          const { PROMEDIO_MORA, OBLIGACIONES } = resp;
          this.onManagementBar = Number(EN_GESTION) || 0;
          this.recoveredBar = Number(RECUPERADOS) || 0;
          this.rectiredBar = Number(RETIRADOS) || 0;
          this.dataReport = OBLIGACIONES;
          this.dataTotalValues = TOTALES;
          this.dataTotalValues.EN_GESTION = parseInt(this.dataTotalValues.EN_GESTION);
          this.dataTotalValues.RECUPERADOS = parseInt(this.dataTotalValues.RECUPERADOS);
          this.obligations = TOTAL_OBLIGACIONES;
          this.dataAverage = PROMEDIO_MORA;
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  getReportDebtors(contrato: string) {
    this.reportsService.getDebtsReport({ contrato }).subscribe(
      (resp: any) => {
        if (resp.REPORTE_DEUDOR) {
          this.dataDeptorReport = resp.REPORTE_DEUDOR[0];
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  management(detalle: any) {
    const datos = this.data;
    this.spinner.show("obligaciones");
    this.spinner.show("gestiones");
    return this.refundsService
      .getDebtsDetails(datos, this.dataAffiliate, detalle)
      .subscribe(
        (resp: any) => {
          this.dataIndividual = resp.CONSULTA_CARTERA_AFILIADO_DET;
          this.existsDataIndividual =
            this.dataIndividual && this.dataIndividual.length < 1
              ? true
              : false;

          if (this.dataIndividual) {
            this.totalObligations = this.dataIndividual.reduce(
              (acc: number, curr: any) => {
                return acc + Number(curr.valor_mora);
              },
              0
            );
            this.actives = this.dataIndividual.length || 0;
          }


          this.cantObligations = this.actives;
          this.totalGeneralReport =
            Number(this.actives) ||
            0 + Number(this.recovered) ||
            0 + Number(this.retired) ||
            0;

          Swal.close();
          this.spinner.hide("obligaciones");
          this.GraficaEstadoGestiones.getStateManagements(this.dataIndividual);
        },
        (err: any) => {
          this.spinner.hide("obligaciones");
          this.existsDataIndividual = true;
          this.dataIndividual = undefined;
          this.GraficaEstadoGestiones.getStateManagements(this.dataIndividual);
          this.spinner.hide("gestiones");
          this.totalObligations = 0;
          this.actives = 0;
          Swal.close();
          this.blankState = true;
          const errorMessage = $(err.error)
            .last()
            .text();
          this.toastr.warning(errorMessage, "", {
            timeOut: 4000
          });
          this.selectedMoments = [];
        }
      );
  }

  webContracts() {
    this.refundsService.getWebContracts(this.data).subscribe(
      (resp: any) => {
        this.dataWebContracts = resp.CONSULTA_CONTRATOS_WEB;
      },
      (err: any) => {
        console.error(err);
        this.dataWebContracts = [];
      }
    );
  }

  getManagement(data: any) {
    if (data) {
      this.dataObj = { ...data };
    }
    this.refundsService.getManagement(this.dataObj).subscribe(
      (resp: any) => {
        this.dataCalls = resp.LLAMADA || 0;
        this.dataChatCenter = resp.CHAT_CENTER || 0;
        this.dataMoreManagements = resp.MAS_GESTIONES || 0;
        this.dataMiCovinoc = resp.MICOVINOC || 0;
        this.dataTotalManagements = resp.TOTAL_GESTION;

        let totalManagement: number;

        if (
          this.dataTotalManagements === "0" ||
          this.dataTotalManagements === 0
        ) {
          totalManagement = 100;
        } else {
          totalManagement = this.dataTotalManagements;
        }

        this.percentManagement = {
          llamadas: Number((this.dataCalls * 100) / totalManagement).toFixed(2),
          chat: Number((this.dataChatCenter * 100) / totalManagement).toFixed(
            2
          ),
          masGestiones: Number(
            (this.dataMoreManagements * 100) / totalManagement
          ).toFixed(2),
          miCovinoc: Number((this.dataMiCovinoc * 100) / totalManagement)
        };
      },
      (err: any) => {
        const errorMessage = $(err.error)
          .last()
          .text();
        console.error(errorMessage);
      }
    );
  }

  showComment(comment: string) {
    comment = comment ? comment : "";
    this.selects.sendMessage(comment);
  }

  getReportCharts(contract: any) {
    this.reportsService.getReportWallet( contract).subscribe(
      (resp: any) => {
        console.log(resp);
        
        this.datas = resp
      },
      (err: any) => {
        console.error(err);
      }
    );
  }
}
